var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{class:[`${_vm.$route.name.split('-').shift()}-mutate-customfields`]},[_c('CustomFields',{attrs:{"value":_vm.value,"schema":_vm.customFieldSchemasComp,"data":_vm.data,"placement":_vm.customFieldsPlacement,"validator":_vm.validator,"validator-prefix":"customFields"},on:{"input":e => _vm.$emit('updateValue', e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }